import { useTranslation } from 'react-i18next';
import vconst from 'utils/helpers/structs/vconst';

interface ObjectStatusBadgeProps {
    status: number;
}

const statusClass = (status: number) => {
    switch (status) {
        case vconst.objectPanding:
            return 'bg-warning text-dark';
        case vconst.objectInWork:
        case vconst.objectFinishedTeam:
            return 'border border-success text-success';
        case vconst.objectFinished:
            return 'bg-success';
        case vconst.objectReject:
            return 'bg-danger';
        default:
            return 'bg-secondary';
    }
};

const ObjectStatusBadge = ({ status }: ObjectStatusBadgeProps) => {
    const { t } = useTranslation(['Objects']);
    const value = Number(status);

    return (
        <span className={`badge fs-12 ${statusClass(value)}`}>
            {t(`status.${value}`)}
        </span>
    );
};

export default ObjectStatusBadge;
